import { render, staticRenderFns } from "./albertactionplan.vue?vue&type=template&id=2ccc4338&"
import script from "./albertactionplan.vue?vue&type=script&lang=js&"
export * from "./albertactionplan.vue?vue&type=script&lang=js&"
import style0 from "./albertactionplan.vue?vue&type=style&index=0&id=2ccc4338&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ccc4338')) {
      api.createRecord('2ccc4338', component.options)
    } else {
      api.reload('2ccc4338', component.options)
    }
    module.hot.accept("./albertactionplan.vue?vue&type=template&id=2ccc4338&", function () {
      api.rerender('2ccc4338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/albert/albertactionplan.vue"
export default component.exports